/**
 * @generated SignedSource<<2d401b16cb07e327a03002ed4bf96ba4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type dataHealthPage_HistoryStartMutation$variables = {
  historyStartOn?: any | null | undefined;
};
export type dataHealthPage_HistoryStartMutation$data = {
  readonly accountHistoryStartSet: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly historyStartOn: any | null | undefined;
  } | null | undefined;
};
export type dataHealthPage_HistoryStartMutation = {
  response: dataHealthPage_HistoryStartMutation$data;
  variables: dataHealthPage_HistoryStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "historyStartOn"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "historyStartOn",
    "variableName": "historyStartOn"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "historyStartOn",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dataHealthPage_HistoryStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountHistoryStartSetMutationPayload",
        "kind": "LinkedField",
        "name": "accountHistoryStartSet",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dataHealthPage_HistoryStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountHistoryStartSetMutationPayload",
        "kind": "LinkedField",
        "name": "accountHistoryStartSet",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "086d40b3ba5f819c619878e338b06eb0",
    "id": null,
    "metadata": {},
    "name": "dataHealthPage_HistoryStartMutation",
    "operationKind": "mutation",
    "text": "mutation dataHealthPage_HistoryStartMutation(\n  $historyStartOn: ISO8601Date\n) {\n  accountHistoryStartSet(historyStartOn: $historyStartOn) {\n    historyStartOn\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d8c3b11e5954e1280a191fa7a1d32a0";

export default node;
